import AudienceEditor from "@/features/audiences/editor/AudienceEditor";
import { storageService } from "@/services/StorageService";
import { useNavigate } from "react-router-dom";

export default function NewAudiencePage() {
  const navigate = useNavigate();

  function onSubmit(audience: any) {
    storageService.saveAudience(audience);
    navigate(`/audiences/${audience.id}`);
  }

  return (
    <>
      <AudienceEditor onSubmit={onSubmit} />
    </>
  );
}
